import StorageService from '../services/storage.service';
import BlockchainService from '../services/blockchain.service';
import { walletConnection } from './type';

export const connect = (formData) => (dispatch) => {
  try {
    let walletDetails = {
      walletAddress: formData.walletAddress,
    };
    StorageService.setObject('wallet', walletDetails);

    dispatch({
      type: walletConnection.SUCCESS,
      payload: walletDetails,
    });
  } catch {
    dispatch({
      type: walletConnection.FAILURE,
    });
  }
};

export const disconnect = () => (dispatch) => {
  try {
    StorageService.purgeData('wallet');
    let metamaskResp = BlockchainService.isMetaMaskInstalled();
    if (metamaskResp.status === 'success') {
      window.ethereum.removeAllListeners();
    }

    dispatch({
      type: walletConnection.DISCONNECT,
      payload: null,
    });
  } catch {
    dispatch({
      type: walletConnection.FAILURE,
    });
  }
};
